import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {AngularFireStorage, AngularFireUploadTask, AngularFireStorageReference} from '@angular/fire/compat/storage';
import {AngularFireFunctions} from '@angular/fire/compat/functions';
import {Member} from '../models/member';
import {Observable, throwError} from 'rxjs';
import {catchError, finalize, map, retry} from 'rxjs/operators';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';

import * as _firebase from 'firebase/app';
import {FormGroup} from '@angular/forms';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {lastValueFrom} from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class MemberService {

  public objectImage: any = null; // store input file for avatar
  public storedImage: any; // store url image for local preview

  public arrayMembersStaff: Member[] = []

  constructor (
    public db: AngularFirestore,
    private fs: AngularFireStorage,
    private ff: AngularFireFunctions,
    private _httpClient: HttpClient,
    private snackBar: SnackBarIconService) { }

  select () {
    return this.db.collection<Member>('sbccv_members', ref =>
      ref.orderBy('name', 'asc')).snapshotChanges();
  }

  selectAll () {
    return this.db.collection<any>('sbccv_members', ref =>
      ref.orderBy('name', 'asc')).snapshotChanges();
  }

  selectByParameterList (list: any[]) {

    let rawList: any[] = list;
    let paramList: string = "";
    let count: number = 0;

    rawList.forEach(item => {
      count += 1
      paramList += item
      if (count != rawList.length)
        paramList += " || "
    });

    console.log("rawList.lenght: " + rawList.length)
    console.log("paramList: " + paramList)


    // return this.db.collection<Member>('sbccv_members', ref => ref
    //  .where("xx", "in", paramList)
    // ).snapshotChanges();

    // .orderBy('name', 'asc')

    return this.db.collection<Member>('sbccv_members', ref => ref
      .where("_firebase.firestore.FieldPath.documentId()", "array-contains", paramList)
    ).get();

  }

  load () {
    return this.db.collection<Member>('sbccv_members', ref => ref
      .orderBy('name', 'asc')).get();
  }

  loadForReports () {
    return this.db.collection<any>('sbccv_members', ref => ref
      .orderBy('name', 'asc')).get();
  }

  loadAll () {
    return this.db.collection<Member>('sbccv_members', ref => ref
      .where('name', '>', '')
      .orderBy('name', 'asc'))
      .snapshotChanges()
      .pipe(
        map(actions => {
          return actions
            .map(a => {
              const data = a.payload.doc.data() as any;
              const id = a.payload.doc.id;
              return {
                ...data,
                id: id,
                situation: data.situation.toString(),
                push: data.zztoken ? true : false,
                created: this.toDate(data.created),
                dateBirth: this.toDate(data.dateBirth),
                dateFiliation: this.toDate(data.dateFiliation),
                dateTitle: this.toDate(data.dateTitle),
                resident_begin: this.toDate(data.resident_begin),
                resident_end: this.toDate(data.resident_end),
              } as Member;
            })
            // 👈 Adicionamos o filtro aqui
            .filter(member => member.deleted !== true);
        })
      );
  }

  toDate (value: any): Date | null {
    return (value && typeof value.toDate === 'function') ? value.toDate() : null;
  };

  loadAsync = async () => {
    return this.db.collection<Member>('sbccv_members', ref => ref
      .orderBy('name', 'asc')).get();
  }

  selectStartAt (val) {
    return this.db.collection<Member>('sbccv_members', ref => ref
      //.where('deleted', '==', false)
      .orderBy('name', 'asc')
      .startAt(val)
      .endAt(val + "\uf8ff")).get();
  }

  selectStaffStartAt (val) {
    return this.db.collection<Member>('sbccv_members', ref => ref
      .where('staff', '==', true)
      .orderBy('name', 'asc')
      .startAt(val)
      .endAt(val + "\uf8ff")).get();
  }

  getById (id) {
    return this.db.doc<Member>('sbccv_members/' + id)
      .get();
  }

  selectByUid (uid) {
    return this.db.collection<Member>('sbccv_members', ref => ref
      .where('uid', '==', uid)
    ).snapshotChanges();
  }

  selectByCellPhone (cellPhone) {
    return this.db.collection<Member>('sbccv_members', ref => ref
      .where('cellPhone', '==', cellPhone)
    ).snapshotChanges();
  }

  selectByDocNumber (doc_number: string) {
    return this.db.collection<Member>('sbccv_members', ref => ref
      .where('cpf', '==', doc_number)
    ).get();
  }

  async selectWithCategories () {
    const array = [];
    const querySnapshot = await this.db.collection('sbccv_members', ref => ref
      .orderBy("name"))
      .get()
      .toPromise();

    querySnapshot.forEach(async (doc: any) => {

      if (doc.data().name.length > 0) {
        array.push({
          "id": doc.id,
          "name": doc.data().name,
          "category_id": doc.data().subCategory.id,
          "category_name": doc.data().subCategory.name,
        })
      }
    })

    return array;

  }

  loadMemberStaff () {

    return this.db.collection<Member>('sbccv_members', ref => ref
      .where('staff', '==', true)
    ).snapshotChanges()
      .subscribe((result) => {
        let array = result.map(item => {
          let entity = new Member();
          entity.id = item.payload.doc.id;
          entity.name = item.payload.doc.data().name;
          entity.email = item.payload.doc.data().email;
          entity.title = item.payload.doc.data().title;
          entity.selected = item.payload.doc.data().selected;
          return entity;
        });

        array.sort(this.compareNames)

        this.arrayMembersStaff = array;

      });


  }

  compareNames (a, b) {
    if (a.name > b.name) return 1;
    if (b.name > a.name) return -1;
    return 0;
  }

  insert (entity: Member) {
    delete entity.id;
    return this.db.collection('sbccv_members').add(Object.assign({}, entity));
  }

  update (entity: Member) {
      return this.db.collection('sbccv_members').doc(entity.id).set(Object.assign({}, entity), {merge: true});
  }

  updateCRM (id: any, data: any) {
    return this.db.collection('sbccv_members').doc(id).set(Object.assign({}, data), {merge: true});
  }

  updateSpeaker (entity: any) {
    //console.log('updateSpeaker: ' + JSON.stringify(entity))
    return this.db.collection('sbccv_speakers_published').doc(entity.id).set(Object.assign({}, entity), {merge: true});
  }

  updateProofOfVaccine (id: string, proof: boolean) {
    return this.db.collection('sbccv_members').doc(id).set({'proofOfVaccine': proof}, {merge: true});
  }

  updateText (id: string, text: string) {
    return this.db.collection('sbccv_members').doc(id).set({'text': text}, {merge: true});
  }

  updateBadge (entity: Member) {
    let id = entity.id;
    //  delete entity.id;
    return this.db.collection('sbccv_members').doc(id).set(
      {
        'name': entity.name,
        'city': entity.city,
        'state': entity.state,
        'country': entity.country
      }, {merge: true});
  }

  updateAuthUid (id: any, authUid: any) {
    return this.db.collection('sbccv_members').doc(id).set(authUid, {merge: true});
  }

  delete (entity_id: any) {
    return this.db.collection('sbccv_members').doc(entity_id).set({'deleted': true}, {merge: true});
  }

  updateCSVMembers (members) {

    members.forEach(element => {
      this.db.collection('sbccv_members').add(Object.assign({}, element))
        .then((result) => {
          console.log("add - " + element.name)
          return element.name + " - add"
        })
        .catch((error) => {
          console.log(JSON.stringify(error))
        })
    });
  }

  updateCSVSituations (situations) {

    const that = this;
    let hasErrors: boolean = false;
    let count: number = 0;

    situations.forEach(situation => {

      situation.cpf = situation.cpf.replace(".", "")
      situation.cpf = situation.cpf.replace(".", "")
      situation.cpf = situation.cpf.replace("-", "")

      let sitRef = this.db.collection('sbccv_members').ref.where('cpf', '==', situation.cpf);
      sitRef.get()
        .then((result) => {
          result.forEach(function (doc) {

            let newSituation: any;
            if (situation.situation == "Quite") {
              newSituation = "0"
            } else if (situation.situation == "Isento") {
              newSituation = "2"
            } else {
              newSituation = "1"
            }

            const entity = {
              category: situation.category,
              situation: newSituation,
              balance: situation.balance,
              obs: situation.obs
            }

            count = count + 1
            console.log(entity)
            console.log(count + "  ----------------------------")

            //that.writeSituation(doc.id, entity)
            this.db.collection('sbccv_members').doc(doc.id).set(entity, {merge: true})
              .then(() => {

              })

          });
        })
        .catch((error) => {
          console.log("error: " + error)
          hasErrors = true
        })
        .finally(() => {
          if (hasErrors) {
            that.snackBar.openSnackBar("Algo Errado", '', 'error');
          } else {
            //   that.snackBar.openSnackBar("Atualizado", '', 'success');
          }

        })
    });

  }

  previewImage (event: any) {

    if (event.target.files.length === 0)
      return;

    var mimeType = event.target.files[ 0 ].type;
    if (mimeType.match(/image\/*/) == null) {
      this.snackBar.openSnackBar("Apenas arquivos .png", '', 'info');
      return;
    }

    var reader = new FileReader();
    this.objectImage = event.target.files[ 0 ];
    reader.readAsDataURL(event.target.files[ 0 ]);
    reader.onload = (_event) => {
      this.storedImage = reader.result;
      // return event.target.files[ 0 ];
    }
  }

  uploadImage (file, entity_id, form: FormGroup) {
    const fsRef: AngularFireStorageReference = this.fs.ref("images/members/" + entity_id + ".png");
    const fsTask: AngularFireUploadTask = fsRef.put(file);

    fsTask.snapshotChanges().pipe(
      finalize(() => {
        fsRef.getDownloadURL().subscribe(url => {
          this.updateImage(entity_id, url, form)
            .then((result) => {
              //  console.log("result: " + JSON.stringify(result))
              form.controls.image.setValue(result);
            })
        });
      }))
      .subscribe();
  }

  updateImage (entity_id: any, image: any, form: any) {
    return this.db.collection('sbccv_members').doc(entity_id).set({image: image}, {merge: true})
      .then(() => {
        this.objectImage = ""
        return image;
      })
      .catch((err) => {
        console.log("erro upadate image: " + JSON.stringify(err))
      })
  }

  makeMsgError (errorsCode) {
    let msgError: string

    switch (errorsCode) {
      case "auth/email-already-exists":
        msgError = "Este email já está em uso"
        break;
      case "auth/phone-number-already-exists":
        msgError = "Este telefone já está em uso"
        break;
      case "auth/invalid-phone-number":
        msgError = "Telefone inválido. Muito longo"
        break;
      case "auth/invalid-password":
        msgError = "Senha deve conter, ao menos, 6 digitos"
        break;
    }

    return msgError
  }

  updateCSVCieloCodes (arrayData) {

    arrayData.forEach(element => {
      this.db.collection('sbccv_cielo_codes').add(Object.assign({}, element))
        .then((result) => {
          console.log("result.id: " + result.id)
        })
        .catch((error) => {
          console.log(JSON.stringify(error))
        })

    });
  }


  getMemberAllAnnuitiesAdmin (member_id): Promise<any> {
    const callable = this.ff.httpsCallable('getMemberAllAnnuitiesAdmin');
    return lastValueFrom(callable({'member_id': member_id}));
  }

  ///////////////////////////////

  requestMemberAllAnnuities (member_id, product_id): Observable<any> {

    let url = 'https://us-central1-sbccv-proj.cloudfunctions.net/requestMemberAllAnnuities';

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    const body: any = {'member_id': member_id, 'product_id': product_id}

    return this._httpClient.post<any>(url, body, httpOptions)
      .pipe(
        retry(2),
        catchError((error) => {
          console.log(error.status)
          return throwError(error.status);
        })
      )
  }

  async getMemberAllAnnuities (member_id, product_id): Promise<any> {
    const getMemberAllAnnuities = this.ff.httpsCallable('getMemberAllAnnuities');
    return getMemberAllAnnuities({'member_id': member_id, 'product_id': product_id})
  }


  /*
  getMemberResidentYears(member_id: any){
    return this.db.doc<any>('sbccv_members_resident/' + member_id)
      .get()
  }
  
  updateMemberResidentYears(member_id, data){
    return this.db.collection('sbccv_members_resident').doc(member_id).set(Object.assign({}, data), {merge: true});
  }
    */
}





